import { useCallback, useEffect, useState } from "react";
import PrimaryButton from "../Buttons/PrimaryButton";
import { ArrowUpward } from "@material-ui/icons";
import classes from "./ScrollToTop.module.css";
import Utils from "../../Utils";

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled up to given distance
  const toggleVisibility = useCallback(() => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, []);

  // Set the scroll event listener
  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, [toggleVisibility]);

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <PrimaryButton
      onClick={scrollToTop}
      className={Utils.getClasses(
        classes.button,
        isVisible ? classes.show : classes.hide
      )}
    >
      <ArrowUpward />
    </PrimaryButton>
  );
}
